<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="4">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formData.date"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="formData.date"
              @input="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            label="Amount"
            prepend-icon="mdi-currency-usd"
            v-model="formData.amount"
            @keypress="isNumber($event)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            :items="[
              'Wire Transfer',
              'Credit Card',
              'Cash',
              'Check',
              'Account Credit'
            ]"
            label="Payment Method"
            v-model="formData.paymentMethod"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            filled
            label="Description"
            auto-grow
            v-model="formData.description"
            :disabled="savingForm == true"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaymentForm",
  props: ["userid", "data", "savingForm", "action"],
  data: () => ({
    formData: {
      date: null,
      amount: null,
      paymentMethod: false,
      description: []
    },
    dateMenu: false
  }),
  computed: {
    clientStoreData() {
      return this.$store.getters.getClients;
    },
    userStoreData() {
      return this.$store.getters.getUsers;
    },
    userAdmin() {
      if (this.loggedInUser.type == "Admin") {
        return true;
      } else {
        return false;
      }
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser;
    },
    validForm() {
      return (
        this.formData.date !== null &&
        this.formData.date !== "" &&
        this.formData.date !== undefined &&
        this.formData.amount !== null &&
        this.formData.amount !== "" &&
        this.formData.amount !== undefined &&
        this.formData.paymentMethod !== null &&
        this.formData.paymentMethod !== "" &&
        this.formData.paymentMethod !== undefined &&
        this.formData.description !== null &&
        this.formData.description !== "" &&
        this.formData.description !== undefined &&
        (this.action != "Edit" ||
          this.formData.date != this.data.date ||
          this.formData.amount != this.data.amount ||
          this.formData.paymentMethod != this.data.paymentMethod ||
          this.formData.description != this.data.description)
      );
    },
    companyId() {
      return this.$store.getters.getCompanyId;
    }
  },
  watch: {
    savingForm(newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        this.$emit(
          "loading",
          this.action == "Delete"
            ? "Deleting Payment"
            : this.action + "ing Payment"
        );
        if (this.action == "Add") {
          this.addPayment();
        } else if (this.action == "Edit") {
          this.editPayment();
        } else if (this.action == "Delete") {
          this.deletePayment();
        }
      }
    },
    validForm(val) {
      if (val == true) {
        this.$emit("valid-form", true);
      } else {
        this.$emit("valid-form", false);
      }
    },
    companyId() {
      this.formData.companyId = this.companyId;
    }
  },
  _methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getChangedData() {
      let changedData = {};
      let oldData = this.data;
      for (var key in this.formData) {
        if (oldData[key] != this.formData[key]) {
          changedData[key] = this.formData[key];
        }
      }

      return changedData;
    },
    editPayment() {
      let self = this;
      self.$store
        .dispatch("editPayment", {
          id: self.data.id,
          changedData: self.getChangedData()
        })
        .then(result => {
          if (result.success != true) {
            self.$emit("error", result.data.error.message);
          } else {
            self.$emit("success", "Successfully edited payment!");
          }
        });
    },
    deletePayment() {
      let self = this;
      if (self.userAdmin == true) {
        self.$store.dispatch("deletePayment", self.formData.id).then(result => {
          if (result.success != true) {
            self.$emit("error", result.data.error.message);
          } else {
            self.$emit("success", "Successfully deleted payment!");
          }
        });
      } else {
        self.$emit("error", "Unable to delete payment.");
      }
    },
    addPayment() {
      let self = this;
      this.formData.companyId = this.companyId;
      self.$store.dispatch("submitPayment", self.formData).then(result => {
        if (result.success != true) {
          self.$emit("error", result.data.error.message);
        } else {
          self.$emit("success", "Successfully added payment!");
        }
      });
    }
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },
  mounted() {
    if (this.data != null) {
      this.formData.clientId = this.data.clientId;
      if (this.action == "Edit") {
        this.formData = JSON.parse(JSON.stringify(this.data));
      }
    }
  }
};
</script>

<style>
.forceuppercase input {
  text-transform: uppercase;
}
</style>
